import { ChipDesignTokens } from '@primeuix/themes/types/chip';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/chip/index.ts
const ch = componentCommon.chip;
const chCs = componentColorScheme.chip;

export const ChipTelekomDT: ChipDesignTokens = {
  root: {
    borderRadius: t(ch.border.radius),
    paddingX: t(ch.padding.x),
    paddingY: t(ch.padding.y),
    gap: t(ch.gap),
    background: t(chCs.background),
    color: t(chCs.color),
  },
  image: {
    width: t(ch.image.width),
    height: t(ch.image.height),
  },
  icon: {
    size: t(ch.icon.size),
    color: t(chCs.icon.color),
  },
  removeIcon: {
    size: t(ch.remove.icon.size),
    color: t(chCs.remove.icon.color),
  },
};
